import { formatYiiFilters } from 'helpers/format-yii-filters'
import { useDataList } from 'hooks/use-data-list'
import { PapeletaService } from '../services/papeleta.service'

const filterOptions = {
    start: ['numero'],
    contain: ['doc_autorizacion', 'beneficiario', 'lugar_viaje'],
    equal: ['estado', 'fecha_creacion'],
}
const tableFields = [
    'numero',
    'doc_autorizacion',
    'beneficiario',
    'lugar_viaje',
    'estado',
    'fecha_creacion',
]
const transformFilters = (filters) => formatYiiFilters(filters, filterOptions)

export function usePapeletas() {
    return useDataList({
        listService: PapeletaService.list,
        transformFilters,
        tableFields,
    })
}
